module.exports = __webpack_public_path__ + "img/banerrojo6.eb517fbd.png";